import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    applicantList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    recruitmentStat: {
        requesting: false,
        error: null,
        success: false,
        data: {
          active_candidates: 0,
          average_time_to_hire: 0,
          offers_extended: 0,
        }
    },
    applicantDetails: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
  };

export const recruitmentSlice = createSlice({
  name: 'recruitment',
  initialState,
  reducers: {
    getApplicantList: (state, action) => {
        state.applicantList.requesting = true;
        state.applicantList.error = null;
        state.applicantList.items = [];
        state.applicantList.success = false;
        state.applicantList.filters = action.payload;
    },
    getApplicantListSuccess: (state, action) => {
      if(action.payload){
		    const { data, current_page, per_page, total} = action.payload;
        state.applicantList.items = data;
        state.applicantList.pagination.current_page = current_page;
        state.applicantList.pagination.per_page = per_page;
        state.applicantList.pagination.total = total;
      }else{
        state.applicantList.pagination.total = 0;
      }

      state.applicantList.requesting = false; 
      state.applicantList.success = true; 
    },
    getApplicantListFail: (state, action) => {        
        state.applicantList.requesting = false;
        state.applicantList.error = action.payload;
    },

    getRecruitmentStat: (state, action) => {
      state.recruitmentStat.requesting = true;
      state.recruitmentStat.error = null;
      state.recruitmentStat.data = {};
      state.recruitmentStat.success = false;
      state.recruitmentStat.filters = action.payload;
    },
    getRecruitmentStatSuccess: (state, action) => {
      state.recruitmentStat.requesting = false;
      state.recruitmentStat.data = action.payload;
      state.recruitmentStat.success = true; 
    },
    getRecruitmentStatFail: (state, action) => {        
      state.recruitmentStat.requesting = false;
      state.recruitmentStat.error = action.payload;
    },

    getApplicantDetails: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.data = null;
        state.applicantDetails.success = false; 
    },
    getApplicantDetailsSuccess: (state, action) => {
        state.applicantDetails.requesting = false;
        state.applicantDetails.data = action.payload;
        state.applicantDetails.success = true; 
    },
    getApplicantDetailsFail: (state, action) => {        
        state.applicantDetails.requesting = false;
        state.applicantDetails.errors = action.payload;
    },

    doAdvanceApplicant: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.success = false; 
    },
  },
})

export const { 
    getApplicantList, getApplicantListSuccess, getApplicantListFail,
    getRecruitmentStat, getRecruitmentStatSuccess, getRecruitmentStatFail,
    getApplicantDetails, getApplicantDetailsSuccess, getApplicantDetailsFail,
    doAdvanceApplicant,
} = recruitmentSlice.actions

export default recruitmentSlice.reducer